import React from 'react'
import {
    Col,
    Grid,
    Row
} from 'react-flexbox-grid'
import Typography from '@material-ui/core/Typography'


export default class PageTitle extends React.Component{
    render(){
		var titles = this.props.titles;
	
	if (titles.subtitle) {
		return(
			<div className="section primary">
			<Row>
				<Col xs={8} xsOffset={2} sm={6} smOffset={3} lg={6} lgOffset={3}>
					<h1 className="title">{titles.title}<span><br/>&mdash;</span></h1>
					<p className="subtitle">{titles.subtitle}</p>
				</Col>
			</Row>
			</div>
		)
	} else {
		return(
			<div className="section primary">
			<Row>
				<Col xs={8} xsOffset={2} sm={6} smOffset={3} lg={6} lgOffset={3}>
					<h1 className="title">{titles.title}</h1>
				</Col>
			</Row>
			</div>
		)
	}
}
}


// WEBPACK FOOTER //
// ./src/components/page-title/index.jsx